module.exports = __webpack_public_path__ + "img/chinesecompany126.7da74153.png";